import type { FaireProductEntity } from "../../entity_types/product";

export const p_q2mr75aw7m: FaireProductEntity = {
  token: "p_q2mr75aw7m",
  type: "product",
  name: "Crinkle Cut Outback BBQ Chips, 1.5oz Bags (15 Pack)",
  brandToken: "b_4lp7ouz3yu",
  brandName: "The Good Crisp Company",
  imageUrl:
    "https://cdn.faire.com/fastly/03cf5252ffc2a7d3bb4e567f91d4b688fd1d1bcc50aa6490e2a3fd1468d1868a.png",
  galleryImageUrls: [],
  priceDollars: 20.77,
  description:
    "Outback BBQ might be a fan favorite at our HQ, (depends who you ask of course) but we can confirm it's on everyone's top list.\n",
  tags: [],
  msrpDollars: 41.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:38.898Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
